import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  /** Internal counter — allows multiple concurrent loading requests */
  private requestCount = signal(0);

  /** True when at least one loading request is active */
  readonly isLoading = computed(() => this.requestCount() > 0);

  /** Show the loader. Call once per async operation. */
  show(): void {
    this.requestCount.update((c) => c + 1);
  }

  /** Hide the loader. Must be called once per show(), even on error. */
  hide(): void {
    this.requestCount.update((c) => Math.max(0, c - 1));
  }

  /** Wraps a promise/async function with automatic loading state.
   *  Usage: await loaderService.wrap(someAsyncFunction());
   *        const result = await loaderService.wrap(fetchData());
   */
  async wrap<T>(promise: Promise<T>): Promise<T> {
    this.show();
    try {
      return await promise;
    } finally {
      this.hide();
    }
  }
}
